export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center bg-gradient-to-br from-purple-500 via-pink-400 to-blue-400 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>

      <div className="relative w-full px-4 sm:px-6 lg:px-20 py-20 sm:py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          <div className="text-center lg:text-left space-y-6 sm:space-y-8 animate-fade-in-up">
            <div className="inline-block">
              <span className="bg-white/90 text-purple-700 text-base sm:text-lg font-bold px-6 py-3 rounded-full shadow-lg">
                AIでAI(アイ＝愛)ある新しい世界を創造する
              </span>
            </div>
            
            <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-black text-white leading-tight tracking-tight">
              AIを、<br />
              あなたの<br />
              ビジネスに<br />
              <span className="bg-gradient-to-r from-yellow-300 to-pink-300 bg-clip-text text-transparent">
                実装する
              </span>
            </h1>
            
            <p className="text-xl sm:text-2xl lg:text-3xl font-bold text-white/95 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              業務設計から定着まで、伴走型で支援。<br />
              AIコンサルティング・ライティング・<br className="hidden sm:block" />
              SNS運用で、確実な成果を実現します。
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-4">
              <a
                href="https://lin.ee/Aq0Iqxs"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white text-purple-700 px-10 py-5 rounded-full font-bold text-lg hover:bg-purple-50 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-chat-3-line text-2xl"></i>
                LINEで相談する
              </a>
              <a
                href="#services"
                className="inline-flex items-center justify-center gap-2 bg-purple-600/80 backdrop-blur-sm text-white border-2 border-white/50 px-10 py-5 rounded-full font-bold text-lg hover:bg-purple-700/80 transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-down-line text-2xl"></i>
                サービスを見る
              </a>
            </div>
          </div>

          <div className="animate-fade-in-up lg:block" style={{ animationDelay: '200ms' }}>
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/d367af92f7f38cbe19d536434073c925/556211aa1cd6be316707d6cd3bfb4a90.png" 
                alt="KIMURAMA WORKS Profile" 
                className="w-full h-[400px] sm:h-[500px] lg:h-[600px] object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-purple-900/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-4xl text-white/80"></i>
      </div>
    </section>
  );
}
